import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotVideoStream from './components/HotVideoStream';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import UserReviews from './components/UserReviews';
import CTASection from './components/CTASection';

const homepageJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吃瓜视频',
    url: 'https://chigua-spa.com',
    description: '吃瓜视频网站每日更新，专注网红黑料实时追踪与明星八卦爆料，提供国产吃瓜视频在线观看完整版延禧攻略等热门内容',
    foundingDate: '2023-01-01',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@chigua-spa.com',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '吃瓜视频',
    url: 'https://chigua-spa.com',
    description: '吃瓜视频 - 网红黑料实时追踪，国产吃瓜视频在线观看完整版延禧攻略',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://chigua-spa.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '吃瓜视频 - 网红黑料实时追踪 国产吃瓜视频在线观看',
    description: '吃瓜视频网站每日更新，专注网红黑料实时追踪与明星八卦爆料，提供国产吃瓜视频在线观看完整版延禧攻略等热门内容',
    url: 'https://chigua-spa.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '吃瓜视频',
      url: 'https://chigua-spa.com',
    },
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '吃瓜视频网站是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '吃瓜视频是国内领先的娱乐八卦内容聚合平台，专注于网红黑料实时追踪、明星八卦爆料、国产吃瓜视频在线观看等服务。网站每日更新，涵盖热门吃瓜视频、塌房现场合集、延禧攻略等经典剧集回顾等丰富内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在吃瓜视频网站观看视频？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '用户可以直接访问吃瓜视频网站（chigua-spa.com），通过首页或分类页面浏览感兴趣的内容。网站支持在线播放，无需下载任何软件，点击即可流畅观看所有吃瓜视频内容。',
        },
      },
      {
        '@type': 'Question',
        name: '吃瓜视频网站有哪些分类内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '吃瓜视频网站涵盖多个热门分类，包括网红黑料、明星八卦、热门吃瓜、国产吃瓜视频、塌房现场、吃瓜合集等。无论您关注网红动态、明星绯闻还是经典剧集回顾，都能在这里找到对应的内容。',
        },
      },
      {
        '@type': 'Question',
        name: '吃瓜视频网站每天更新吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，吃瓜视频网站坚持每日更新，团队实时追踪全网最热门的网红塌房现场和明星黑料猛料，确保用户能够第一时间获取最新、最全的吃瓜内容。',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <SEO
        title="吃瓜视频 - 网红黑料实时追踪 国产吃瓜视频在线观看完整版延禧攻略"
        description="吃瓜视频网站每日更新，本站专注吃瓜视频在线资源，覆盖国产吃瓜视频、吃瓜视频网站及吃瓜视频在线观看完整版延禧攻略等热门内容，每日追踪网红塌房现场与明星黑料猛料，提供吃瓜视频在线播放与在线观看吃瓜视频的流畅体验。"
        keywords="吃瓜视频在线, 吃瓜视频网站, 国产吃瓜视频, 吃瓜视频网, 吃瓜视频在线播放, 在线观看吃瓜视频, 吃瓜视频在线观看, 吃瓜视频官网, 吃瓜视频入口, 吃瓜视频app, 吃瓜视频下载, 吃瓜视频最新地址"
        canonicalUrl="/"
        jsonLd={homepageJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotVideoStream />
        <CategoryGrid />
        <AboutSection />
        <UserReviews />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}